import React from 'react'
import { IProps } from './Interface'
import { Balloon } from 'components'
import { Corner } from 'components/balloon'
import { Typography, Box, Grid, useMediaQuery } from '@material-ui/core'
import useStyles from './Styles'
import { Section } from 'components/section'
import { theme } from 'config/constants/theme/theme'

const DidYouKnowPageDisplay: React.FC<IProps> = props => {
  const classes = useStyles({})
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const borderRadius = downMd ? {} : { topLeft: 0, topRight: 0, bottomLeft: 0, bottomRight: 0 }
  const balloonSize = downMd ? 270 : 235

  const items = [
    {
      title: 'Fun fact about me',
      answer: 'funFact',
      corner: Corner.BottomLeft,
      bgColor: '#314DA1'
    },
    {
      title: 'A personal statistic',
      answer: 'statDetail',
      answerTitle: 'statNum',
      corner: Corner.TopLeft,
      bgColor: '#F26723'
    },
    {
      title: 'A random job I’d be really good at',
      answer: 'randomJob',
      corner: Corner.TopRight,
      bgColor: '#2166A4'
    },
    {
      title: 'Unique interests',
      answer: 'uniqueInterest',
      corner: Corner.BottomRight,
      bgColor: '#413292'
    },
    {
      title: 'One day I’ll do a Ted Talk on',
      answer: 'tedTalk',
      corner: Corner.BottomLeft,
      bgColor: '#64CCE9'
    },
    {
      title: 'If I could bring a project to life, it would be',
      answer: 'projectToLife',
      corner: Corner.TopLeft,
      bgColor: '#FDB72A'
    }
  ]

  const content = (
    <Grid container spacing={2} className={classes.root} wrap={'wrap'}>
      {items.map((item, index) => (
        <Grid key={index} item hidden={!props[item.answer]} md={4} sm={6} xs={12}>
          <Balloon corner={item.corner} bgColor={item.bgColor} size={balloonSize}>
            <Box pt={5} px={4} className={classes.content}>
              <Typography id={`did-you-know-${item.answer}-label`} className={classes.title}>
                {item.title}
              </Typography>
              <Typography id={`did-you-know-${item.answer}-answer`} className={classes.answer}>
                {props[item.answerTitle] ? `${props[item.answerTitle]}: ${props[item.answer]}` : props[item.answer]}
              </Typography>
            </Box>
          </Balloon>
        </Grid>
      ))}
    </Grid>
  )

  return (
    <Grid container direction={'column'}>
      {props.embeddedPage ? (
        content
      ) : (
        <Section padding={'0 50px 0 50px'} direction={'column'} borderRadius={borderRadius}>
          {content}
        </Section>
      )}
    </Grid>
  )
}

DidYouKnowPageDisplay.defaultProps = {
  embeddedPage: false
}

export default (props: IProps) => <DidYouKnowPageDisplay {...props} />
